import type { Group, User } from '@microsoft/microsoft-graph-types'

import { BaseService, type IAuthService } from '@/services'
import { MicrosoftGraphBaseURL, MicrosoftGraphEndpoints, MicrosoftGraphScopes } from '@/services/MicrosoftGraph'
export type { Group, User }
export class MicrosoftGraphService extends BaseService {
	constructor(authService: IAuthService) {
		super(MicrosoftGraphBaseURL, authService, MicrosoftGraphScopes)
	}

	async getMe(): Promise<User> {
		return this.getData<User>(MicrosoftGraphEndpoints.me).then((res) => {
			return res
		})
	}
	async getGroups(): Promise<Group[]> {
		return this.getData<{ context: string; value: Group[] }>(MicrosoftGraphEndpoints.group).then((res) => {
			return res.value
		})
	}
	async getPhoto(): Promise<string> {
		const options = { responseType: 'blob' }
		return this.getData<Blob>(`${MicrosoftGraphEndpoints.photo}/240x240/$value`, {}, options)
			.then((data) => {
				return URL.createObjectURL(data)
			})
			.catch((err) => {
				console.log(err)
				return ''
			})
	}
	async searchUsers(searchString: string, max = 50): Promise<User[]> {
		return this.getData<{ context: string; tips: string; value: User[] }>(
			`/users?$filter=startswith(displayName, '${searchString}')
	        or startswith(userPrincipalName, '${searchString}')&$top=${max}`
		).then((res) => {
			return res.value
		})
	}
}
